import React, { useEffect, useRef, useState } from 'react'
import Images from '../../../Assets/images/Images'
import style from "./Affiliates.module.css"

const logoList = [
  // { image: Images.cqc, alt: 'CQC', link: 'https://www.cqc.org.uk/location/1-10528758258' },
  { image: Images.bild, alt: 'BM', link: 'https://www.bild.org.uk/membership/' },
  { image: Images.dcc, alt: 'DCC', link: 'https://www.gov.uk/government/publications/disability-confident-guidance-for-levels-1-2-and-3/level-1-disability-confident-committed' },
  { image: Images.ico, alt: 'ICO', link: 'https://ico.org.uk' },
  { image: Images.rrn, alt: 'RRN', link: 'https://restraintreductionnetwork.org' },
  { image: Images.ikon, alt: 'IKON', link: 'https://ikontraining.co.uk' },
  { image: Images.shropshire, alt: 'SHROPSHIRE COUNCIL', link: 'https://next.shropshire.gov.uk/' },
  { image: Images.telford, alt: 'TELFORD COUNCIL', link: 'https://telford.gov.uk' },
  { image: Images.coventry, alt: 'COVENTRY COUNCIL', link: 'https://www.coventry.gov.uk/' },
  { image: Images.stoke, alt: 'STOKE-ON-TRENT COUNCIL', link: 'https://www.stoke.gov.uk/' },
  { image: Images.icb, alt: 'ICB', link: 'https://www.shropshiretelfordandwrekin.nhs.uk/' },
  { image: Images.inclusion, alt: 'INCLUSION HOUSING', link: 'https://www.inclusion-group.org.uk/inclusion-housing/' },
  { image: Images.halo, alt: 'HALO HOUSING', link: 'https://halohousing.co.uk/' },
  { image: Images.ironoak, alt: 'IRONOAK HOUSING', link: 'https://homes.ironoak.org.uk/' },
  { image: Images.partners, alt: 'PARTNERS IN CARE', link: 'https://www.partnersincare.org.uk/' },
  { image: Images.skills, alt: 'SKILLS FOR CARE', link: 'https://www.skillsforcare.org.uk/' },
]

const Affiliates = () => {
  const [visible, setVisible] = useState(false)

  const sectionRef = useRef(null)
  const carouselRef = useRef(null)

  const isPausedRef = useRef(false)
  const touchTimerRef = useRef(null)

  // Fade in
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.2 }
    )

    if (sectionRef.current) observer.observe(sectionRef.current)

    return () => observer.disconnect()
  }, [])

  // Auto scroll (single direction, stop at end)
  useEffect(() => {
    const el = carouselRef.current
    if (!el) return

    let frameId
    const speed = 0.6

    const loop = () => {
      if (!isPausedRef.current) {
        el.scrollLeft += speed

        const maxScroll = el.scrollWidth - el.clientWidth

        if (el.scrollLeft >= maxScroll) {
          el.scrollLeft = maxScroll
        }
      }

      frameId = requestAnimationFrame(loop)
    }

    frameId = requestAnimationFrame(loop)

    return () => {
      cancelAnimationFrame(frameId)
      clearTimeout(touchTimerRef.current)
    }
  }, [])

  // Touch handlers
  const handleTouchStart = () => {
    clearTimeout(touchTimerRef.current)
    isPausedRef.current = true
  }

  const handleTouchEnd = () => {
    touchTimerRef.current = setTimeout(() => {
      isPausedRef.current = false
    }, 1500)
  }

  return (
    <section ref={sectionRef} className={style.wrapper}>
      <div className={style.inner}>
      <div className={style.edgeFade}>
        <div
          className={style.carousel}
          ref={carouselRef}
          onMouseEnter={() => (isPausedRef.current = true)}
          onMouseLeave={() => (isPausedRef.current = false)}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          onTouchCancel={handleTouchEnd}
        >
          <div className={style.track}>
            {logoList.map((logo, index) => (
              <a
                key={index}
                href={logo.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`${style.logoCard} ${visible ? style.show : ""}`}
                style={{
                  transitionDelay: `${index * 0.1}s`,
                }}
              >
                <img src={logo.image} alt={logo.alt} className={style.logo} />
              </a>
            ))}
          </div>
        </div>
      </div>
      </div>
    </section>
  )
}


export default Affiliates
